import * as angular from "angular";
import {IWindowService} from "angular";
import {Direction} from "@angular/cdk/bidi";


export class SiteContextService {
  currentSiteInfo: any;
  memberPermissions: {
    roles: any[],
    expirationByPolicies: any[] // {policyId, expireAt}
  };

  constructor(private $window: IWindowService) {
  }

  isSite() {
    return !!this.currentSiteInfo;
  }

  getSiteInfo() {
    if (!!this.currentSiteInfo) {
      return this.currentSiteInfo
    }
    throw new ReferenceError()
  }

  setSiteInfo(siteInfo) {
    this.currentSiteInfo = siteInfo;
    this.$window.localStorage.setItem('siteLocale', siteInfo.language);
  }

  getMemberPermissions() {
    return this.memberPermissions;
  }

  setMemberPermissions(memberPermissions) {
    this.memberPermissions = memberPermissions;
  }

  resetSite() {
    this.currentSiteInfo = undefined;
    this.memberPermissions = undefined;
    this.$window.sessionStorage.removeItem('currentSiteId');
    this.$window.localStorage.removeItem('siteLocale');
  }
}

angular
  .module('bringoz.admin.commons')
  .service('siteContextService', SiteContextService);
